module.exports = ":host {\n  display: block;\n  padding: 15px; }\n"